const NotificationPlugin = {
    install(Vue) {
      Vue.prototype.$success = function() {
        this.$notify({
          title: '成功',
          message: '操作成功',
          type: 'success'
        });
      };
  
      Vue.prototype.$warning = function(res) {
        this.$notify({
          title: '警告',
          message: res,
          type: 'warning'
        });
      };
  
      Vue.prototype.$info = function(res) {
        this.$notify({
          title: '消息',
          message: res
        });
      };
  
      Vue.prototype.$error = function(res) {
        this.$notify({
          title: '错误',
          message: res,
          type: 'error'
        });
      };
    }
  };
  
  export default NotificationPlugin;